import React from 'react';
import styled from 'styled-components';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import FrontSvg from './Front/FrontSvg';
import BackSvg from './Back/BackSvg';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-left: 20px;
`;

const StyledForm = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(11, 50px);
`;

const CarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 550px;
`;

const styles = theme => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        width: 300
    }
});

const DamageTab = props => {
    const {damage, classes} = props;

    return (
        <Wrapper>
            <CarContainer>
                <h3>Zaznacz element i opisz uszkodzenie</h3>

                <FrontSvg
                    damage={damage}
                    onChange={props.onDamageChangeHandler}
                />

                <BackSvg
                    damage={damage}
                    onChange={props.onDamageChangeHandler}
                />

            </CarContainer>
            <FormWrapper>
                <h3>Lista uszkodzeń</h3>
                <StyledForm>
                    {Object.entries(props.damage)
                        .filter(damage => damage[1] === true)
                        .map(damage => (
                            <TextField
                                key={damage[0]}
                                id="standard-multiline-static"
                                label={damage[0]
                                    .split("_")
                                    .slice(0, -1)
                                    .join(" ")}
                                multiline
                                name={`${damage[0]
                                    .split("_")
                                    .slice(0, -1)
                                    .join("_")}_opis`}
                                onChange={props.onDamageDescriptionChangeHandler}
                                rowsMax="4"
                                className={classes.textField}
                                margin="normal"
                                value={
                                    props.damage[`${damage[0].split("_").slice(0, -1).join("_")}_opis`]
                                        ? props.damage[`${damage[0].split("_").slice(0, -1).join("_")}_opis`]
                                        : ""
                                }
                            />
                        ))}
                </StyledForm>
            </FormWrapper>
        </Wrapper>
    );
};

export default withStyles(styles)(DamageTab);
